// extracted by mini-css-extract-plugin
export var chip = "_mk-2";
export var chipBody = "_mk-8";
export var chipHeader = "_mk-9";
export var chipWithKind = "_mk-7";
export var icon = "_mk-3";
export var kind = "_mk-a";
export var remove = "_mk-5";
export var removeIcon = "_mk-6";
export var row = "_mk-0";
export var rowHistorical = "_mk-1";
export var text = "_mk-4";